module.exports = __webpack_public_path__ + "static/ziggy_report-en-da4a21691188c16d46b5377abcf59066.png";